
export default {
  name: 'icon-status-canceled',
};
